import { api } from './client';
import type { TravelStats, WorldMapData } from '../types';

/** ADR-0045: computed by the server; the client only draws. */
export const statsApi = {
  travelStats: () =>
    api.get<TravelStats>('/users/me/travel-stats').then(r => r.data),
  worldMap: () =>
    api.get<WorldMapData>('/world-map').then(r => r.data),
};
